import input from './input-message'

export default class FileSizeValidator {
  constructor(inputFile, maxSize) {
    this.inputFile = inputFile
    this.maxSize = maxSize
  }

  addEventListeners() {
    this.inputFile.addEventListener('change', (e) => {
      const inputFile = e.target
      const uploadedFileSize = inputFile.files[0].size / (1024 * 1024)
      if (uploadedFileSize > this.maxSize) {
        inputFile.value = ''
        const fieldName = inputFile.getAttribute('field-name') || 'ファイル'
        input.showError(inputFile, `${fieldName}は${this.maxSize}MB以内にしてください`)
      } else {
        input.removeMessageElement(inputFile)
      }
    })
  }
}
